import { Button, createStyles, Grid, makeStyles, Typography } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { PremiumInfoVideo } from 'src/components/account/data/premium-program/PremiumInfoVideo';
import AccountTabs from 'src/components/account/elements/account-tabs/AccountTabs';
import T from 'src/components/content-manager/translator/T';
import { ROUTE_ACCOUNT_DATA_PREMIUMPROGRAM } from 'src/config/account-routes';
import { useAccount } from 'src/core/hooks/account';
import VolumeDiscount from 'src/entities/volume-discount/VolumeDiscount';
import { getEntities } from 'src/store/entities/selectors';
import { EntityDescriptions } from 'src/store/entities/types';
import { EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';
import { VolumeDiscountTab } from './VolumeDiscountTab';

const useStyles = makeStyles(theme =>
    createStyles({
        buttons: {
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            gap: theme.spacing(4),
        },
    })
);

interface VolumeDiscountTabsProps {
    filterArticleGroups?: string[];
}

export const VolumeDiscountTabs: React.FC<VolumeDiscountTabsProps> = ({ filterArticleGroups }) => {
    const classes = useStyles();
    const { isLoggedIn } = useAccount();

    const volumeDiscounts: EntityCollectionState<VolumeDiscount> = useSelector(state =>
        getEntities(state, EntityDescriptions.VOLUME_DISCOUNT)
    );

    const tabs = useMemo(
        () =>
            volumeDiscounts.items
                .filter(item => filterArticleGroups?.includes(item.articleGroupNormalizedName) ?? true)
                .map(discount => ({
                    tabLabel: discount.articleGroupLocalizedName,
                    content: <VolumeDiscountTab volumeDiscount={discount} />,
                })),
        [filterArticleGroups, volumeDiscounts.items]
    );

    if (volumeDiscounts.isFetching) return null;

    return (
        <Grid container spacing={2} direction="column">
            <Grid item>
                <Typography variant="h3" color="primary" gutterBottom>
                    <T k="shop.volume_discount_discover.heading" />
                </Typography>
                <Typography variant="body3" component="p">
                    <T k="shop.volume_discount_discover.body" />
                </Typography>
            </Grid>
            <Grid item>
                <AccountTabs tabs={tabs} />
            </Grid>
            <Grid item className={classes.buttons}>
                <PremiumInfoVideo />
                {isLoggedIn && (
                    <Button
                        variant="contained"
                        color="primary"
                        component={Link}
                        to={ROUTE_ACCOUNT_DATA_PREMIUMPROGRAM.path}>
                        <T k={ROUTE_ACCOUNT_DATA_PREMIUMPROGRAM.t_long} />
                    </Button>
                )}
            </Grid>
        </Grid>
    );
};
